import { ResponseViewProps } from 'models/props/ResponseViewProps';
import 'assets/scss/response-view.scss';
import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';

interface ResponseProps {
	data?: ResponseViewProps;
}

export const ResponseView = ({ data }: ResponseProps) => {
	useEffect(
		() => {
			TagManager.dataLayer({
				dataLayer: data?.dataLayer ? data?.dataLayer : undefined,
			});
		},
		//eslint-disable-next-line
		[]
	);

	return (
		<div className="responseview">
			<img src={data?.icon} className="responseview-icon" alt="icon" />
			{data?.title ? <h1 className="title-4 new-title-color">{data?.title}</h1> : null}
			{data?.subtitle ? <h2 className="subtitle-2 gris-6">{data?.subtitle}</h2> : null}
			{data?.body ? <div className="responseview-body body gris-6">{data?.body}</div> : null}
			{data?.extras ? <div className="responseview-extras">{data?.extras}</div> : null}
		</div>
	);
};
